import React from 'react';
import { Spin } from 'antd';
import { useQuery } from '@tanstack/react-query';
import { getCampaignOnboarding } from '@/api/novi/campaigns';
import { CampaignSetupContent } from './CampaignSetupContent';
// import CampaignSettings from './CampaignSettings';

interface CampaignSetupPageProps {
	isPageView?: boolean;
	totalSteps?: number;
	campaignId: string;
	resellerView: boolean;
	standAloneCampaignView: boolean;
}

export const CampaignSetup: React.FC<CampaignSetupPageProps> = ({
	isPageView = false,
	totalSteps = 6,
	campaignId,
	resellerView,
	standAloneCampaignView = false,
}) => {
	// Move the fetch logic here
	const { data: onboardingData, isLoading } = useQuery({
		queryKey: ['campaign-onboarding', campaignId],
		queryFn: () => getCampaignOnboarding({ agentId: campaignId as string }),
		enabled: !!campaignId,
	});

	// Early return conditions
	if (isLoading) {
		return isPageView ? (
			<div className="flex items-center justify-center min-h-screen">
				<Spin size="large" />
			</div>
		) : null;
	}

	// If not page view and all steps are done, return null
	if (!isPageView && (onboardingData?.steps || []).length >= totalSteps) {
		return null;
	}

	// if (isPageView) {
	//   return <CampaignSettings />;
	// }
	// Default Modal + Float view
	return (
		<CampaignSetupContent
			resellerView={resellerView}
			doneSteps={onboardingData?.steps || []}
			totalSteps={standAloneCampaignView ? 7 : totalSteps}
			isPageView={false}
			standAloneCampaignView={standAloneCampaignView}
		/>
	);
};
